import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyA5GYsMr_koYmWrE7MtY_xPHQcIbdxPSzg",
  authDomain: "wf-property-manager.firebaseapp.com",
  databaseURL: "https://wf-property-manager.firebaseio.com",
  projectId: "wf-property-manager",
  storageBucket: "wf-property-manager.appspot.com",
  messagingSenderId: "425581743180",
  appId: "1:425581743180:web:0eee2c2f378a343bfc38e9",
  measurementId: "G-LCJQ2VMY7S"
};

firebase.initializeApp(firebaseConfig);

export default {
  auth: firebase.auth(),
  fbAnalytics: firebase.analytics(),
  db: firebase.firestore(),
  login() {
    const provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithPopup(provider)
      .then(function(result) {
        console.log(result);
        firebase.analytics().logEvent('user_login');
      })
      .catch(function(error){
        const errorCode = error.code;
        const errorMessage = error.message;
        const email = error.email;
        const credential = error.credential;
        console.log(errorCode, errorMessage, email, credential);
      })
  },
  logout() {
    firebase.auth().signOut()
      .then(function() {
        firebase.analytics().logEvent('user_logout');
      })
      .catch(function(error) {
        console.log(error)});
  },
}
